/* istanbul ignore file */

import { Carriers } from '../constants/carriers';
import northAmericanUri from './assets/NorthAmericanLogo.png';
import { CarrierConfig } from './carrierConfig';

export class CarrierNorthAmerican extends CarrierConfig {
  getCarrier(): Carriers {
    return Carriers.NORTH_AMERICAN;
  }
  getCarrierDisplayName(): string {
    return 'North American, a Sammons Financial Company';
  }
  getLabel(): string {
    return 'North American';
  }
  getCarrierLogo(): string {
    return northAmericanUri;
  }
  supportLetterGeneration(): boolean {
    return true;
  }
  getLetterFooterText(): string {
    return 'Sammons Financial® is the marketing name for Sammons® Financial Group, Inc.’s member companies, including North American Company for Life and Health Insurance®. Annuities and life insurance are issued by, and product guarantees are solely the responsibility of, North American Company for Life and Health Insurance.';
  }
}
